import stickybits from 'stickybits/dist/stickybits'

$(()=> {
  document.querySelectorAll('.sticky').forEach((el)=>{
    stickybits(el, {
      stickyBitStickyOffset: parseInt(el.dataset.stickyOffset)
    });
  })
})
